import { render, staticRenderFns } from "./MyStudio.vue?vue&type=template&id=2da5bf9d&scoped=true&"
import script from "./MyStudio.vue?vue&type=script&lang=js&"
export * from "./MyStudio.vue?vue&type=script&lang=js&"
import style0 from "./MyStudio.vue?vue&type=style&index=0&id=2da5bf9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5bf9d",
  null
  
)

export default component.exports